import { initialState } from './initialState'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { NavigationSlice } from '../../../classes/store'

export const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    cameraPostionUpdate: (state, { payload }: PayloadAction<number[]>) => {
      NavigationSlice.cameraPostionUpdate(state, payload)
    },
  },
})

// Component
export const navigationSliceActions = navigationSlice.actions

// Store
export const navigationReducer = navigationSlice.reducer
